import { watch } from "vue";
import { isLuxuryMerchantId, parseLuxuryMerchants } from "~/utils/luxury.utils";

export default defineNuxtPlugin(() => {
  const appStateStore = useAppStateStore();
  const {
    public: { luxuryMerchant },
  } = useRuntimeConfig();

  const luxuryMerchants = parseLuxuryMerchants(luxuryMerchant);
  const htmlElement = document.documentElement;

  const applyLuxuryDesign = (merchantId?: string | null) => {
    const isLuxury = isLuxuryMerchantId(merchantId ?? null, luxuryMerchants);
    htmlElement.classList.toggle("no-round", isLuxury);
    htmlElement.classList.toggle("luxury-merchant", isLuxury);

    if (merchantId) {
      htmlElement.setAttribute("data-current-merchant", merchantId);
    } else {
      htmlElement.removeAttribute("data-current-merchant");
    }
  };

  applyLuxuryDesign(appStateStore.currentMerchant.value);

  watch(
    () => appStateStore.currentMerchant.value,
    (newMerchant) => {
      applyLuxuryDesign(newMerchant);
    }
  );
});
